'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PluginError = function (_Error) {
  _inherits(PluginError, _Error);

  function PluginError(message, fileName, lineNumber) {
    _classCallCheck(this, PluginError);

    var _this = _possibleConstructorReturn(this, (PluginError.__proto__ || Object.getPrototypeOf(PluginError)).call(this, message, fileName, lineNumber));

    _this.name = 'PluginError';
    return _this;
  }

  return PluginError;
}(Error);

exports.default = PluginError;


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/plugin-error.js
// module id = 347
// module chunks = 0